import React, { Dispatch, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AnyAction } from '@reduxjs/toolkit'
import { GameState } from '../../../redux/types/game'
import { getGameSelector } from '../../../redux/selectors/gameSelectors'
import clickSoundEffect from '../../../assets/audio/click2.wav'
import {
  fetchGameCodeRequest,
  fetchLeaderboardRequest,
  fetchTeamOnLeaderboardRequest,
  postLogoutRequest,
} from '../../../redux/actions/gameActions'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { ArrowLeft2, ArrowRight2, Copy, Logout, Map } from 'iconsax-react'
import { intervalToDuration } from 'date-fns'
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterIcon,
  TwitterShareButton,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
  ViberShareButton,
  ViberIcon,
} from 'react-share'
import { Button } from 'primereact/button'
import jwt_decode from 'jwt-decode'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Ripple } from 'primereact/ripple'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import { classNames } from 'primereact/utils'
import useSound from 'use-sound'
import RateButton from '../components/RateButton'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { showSuccessNotification } from './../../../redux/actions/notificationActions'
import { useTranslation } from 'react-i18next'

const style = {
  root: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    borderRadius: 3,
    border: 0,
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    color: 'white',
  },
  copyContainer: {
    border: '1px solid blue',
    background: 'rgb(0,0,0,0.7)',
    display: 'none',
  },
  title: {
    color: 'aquamarine',
    fontStyle: 'italic',
  },
}

const Leaderboard = () => {
  const [searchParams] = useSearchParams()
  const showRateAndSocial = searchParams.get('showRateAndSocial') === 'true'
  const {
    data: { teamOnLeaderboard, gameCode, leaderboard, volumeGlobal, branding },
    loading: gameLoading,
  }: GameState = useSelector(getGameSelector)
  const dispatch: Dispatch<AnyAction> = useDispatch()
  // const [first, setFirst] = useState(0)
  const [pagination, setPagination] = useState<any>({
    first: 0,
    rows: 10,
    page: 1,
  })
  const [rows, setRows] = useState(10)
  const navigate = useNavigate()
  // const [first, setFirst] = useState(0)
  const token = localStorage.getItem('tokenCityHunt') ?? ''
  const [pageInputTooltip, setPageInputTooltip] = useState(
    "Press 'Enter' key to go to this page.",
  )
  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })
  const { t } = useTranslation()

  const { GameType }: any = jwt_decode(token)

  useEffect(() => {
    dispatch(fetchGameCodeRequest())
  }, [])

  useEffect(() => {
    if (gameCode) {
      dispatch(
        fetchLeaderboardRequest({
          page: 1,
          perPage: rows,
        }),
      )
      dispatch(fetchTeamOnLeaderboardRequest())
    }
  }, [gameCode])

  const renderHeader = () => {
    return (
      <div className="flex flex-wrap justify-content-center align-items-center">
        <h5 className="m-0" style={{ color: '#333' }}>
          {t('Leaderboard')}
        </h5>
        {/* <span className="p-input-icon-left mt-3">
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
          />
        </span> */}
      </div>
    )
  }

  const header = renderHeader()

  const onPage = (event: any) => {
    dispatch(
      fetchLeaderboardRequest({
        // gameId: gameCode,
        page: event.page + 1,
        perPage: event.rows,
      }),
    )
    setPagination({
      first: event.first,
      rows: event.rows,
      page: event.page + 1,
    })
    //imitate delay of a backend call
    // setTimeout(() => {
    //   const startIndex = event.first
    //   const endIndex = event.first + rows

    //   setFirst(startIndex)
    // }, 250)
  }

  const getTimeSpentOnPuzzles = (time: number | undefined) => {
    if (!time) {
      return '00:00:00'
    }
    // Ensure the end time is greater than or equal to the start time
    if (time < 0) {
      return '0'
    }
    try {
      const duration = intervalToDuration({ start: 0, end: time * 1000 })
      const zeroPad = (num: number | undefined) => String(num).padStart(2, '0')

      const formatted = [duration.hours, duration.minutes, duration.seconds]
        .map(zeroPad)
        .join(':')
      return formatted
    } catch (error) {
      return '0'
    }
  }

  const timeSpentBodyTemplate = (rowData: any) => {
    return getTimeSpentOnPuzzles(rowData.totalSeconds)
  }

  const rowClass = (data: any) => {
    const generateCssClass = () => {
      if (document.querySelector('.leaderboard-team-row')) {
        return true
      }
      const styleSheet = document.createElement('style')
      styleSheet.type = 'text/css'
      styleSheet.id = 'leaderboard-team-row'

      const style = `.leaderboard-team-row { color: ${branding?.buttonPrimary.textColor} !important;background-color: ${branding?.buttonPrimary.backgroundColor} !important; }`
      styleSheet.appendChild(document.createTextNode(style))

      document.head.appendChild(styleSheet)
      console.log(document.head)
      return true
    }

    return {
      'leaderboard-team-row':
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        data.id === teamOnLeaderboard?.id ? generateCssClass() : false,
    }
  }

  const onIndexTemplate = (data: any, props: any) => {
    return props.rowIndex + 1
  }

  const onPageInputKeyDown = (event: any, options: any) => {
    if (event.key === 'Enter') {
      const page = parseInt(pagination.page)
      if (page < 1 || page > options.totalPages) {
        setPageInputTooltip(
          `Value must be between 1 and ${options.totalPages}.`,
        )
      } else {
        const first = pagination.page ? options.rows * (page - 1) : 0

        setPagination({ ...pagination, first })
        setPageInputTooltip("Press 'Enter' key to go to this page.")
      }
    }
  }

  const template2 = {
    layout: 'PrevPageLink CurrentPageReport NextPageLink',
    // layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    // RowsPerPageDropdown: (options: any) => {
    //   const dropdownOptions = [
    //     { label: 10, value: 10 },
    //     { label: 20, value: 20 },
    //     { label: 50, value: 50 },
    //   ]

    //   return (
    //     <React.Fragment>
    //       <span
    //         className="mx-1"
    //         style={{ color: 'var(--text-color)', userSelect: 'none' }}
    //       >
    //         Items per page:{' '}
    //       </span>
    //       <Dropdown
    //         value={options.value}
    //         options={dropdownOptions}
    //         onChange={options.onChange}
    //       />
    //     </React.Fragment>
    //   )
    // },
    CurrentPageReport: (options: any) => {
      return (
        <span
          style={{
            color: 'var(--text-color)',
            userSelect: 'none',
            width: '120px',
            textAlign: 'center',
          }}
        >
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    },
    PrevPageLink: (options: any) => {
      return (
        <button
          type="button"
          className={classNames(options.className, 'mr-2')}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span>
            <ArrowLeft2 size="32" color="#000" variant="Bold" />
          </span>
          <Ripple />
        </button>
      )
    },
    NextPageLink: (options: any) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span>
            <ArrowRight2 size="32" color="#000" variant="Bold" />
          </span>
          <Ripple />
        </button>
      )
    },
  }

  const templatePaginator = {
    layout:
      'PrevPageLink PageLinks NextPageLink RowsPerPageDropdown CurrentPageReport',
    PrevPageLink: (options: any) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-3">
            <ArrowLeft2 size="32" color="var(--primary-color)" variant="Bold" />
          </span>
          <Ripple />
        </button>
      )
    },
    NextPageLink: (options: any) => {
      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
          disabled={options.disabled}
        >
          <span className="p-3">
            <ArrowRight2
              size="32"
              color="var(--primary-color)"
              variant="Bold"
            />
          </span>
          <Ripple />
        </button>
      )
    },
    PageLinks: (options: any) => {
      if (
        (options.view.startPage === options.page &&
          options.view.startPage !== 0) ||
        (options.view.endPage === options.page &&
          options.page + 1 !== options.totalPages)
      ) {
        const className = classNames(options.className, { 'p-disabled': true })

        return (
          <span className={className} style={{ userSelect: 'none' }}>
            ...
          </span>
        )
      }

      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          {options.page + 1}
          <Ripple />
        </button>
      )
    },
    RowsPerPageDropdown: (options: any) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 'All', value: options.totalRecords },
      ]

      return (
        <Dropdown
          value={options.value}
          options={dropdownOptions}
          onChange={options.onChange}
        />
      )
    },
    CurrentPageReport: (options: any) => {
      return (
        <span
          className="mx-3"
          style={{ color: 'var(--text-color)', userSelect: 'none' }}
        >
          Go to{' '}
          <InputText
            size={2}
            className="ml-1"
            value={pagination.currentPage}
            tooltip={pageInputTooltip}
            onKeyDown={(e) => onPageInputKeyDown(e, options)}
            onChange={onPageInputChange}
          />
        </span>
      )
    },
  }

  const onPageInputChange = (event: any) => {
    setPagination({ ...pagination, page: event.target.value })
  }

  const isAnyReviewFilled = () => {
    if (teamOnLeaderboard) {
      const {
        tripAdvisorReviewUrl,
        yelpReviewUrl,
        facebookReviewUrl,
        googleReviewUrl,
      } = teamOnLeaderboard
      if (
        tripAdvisorReviewUrl ||
        yelpReviewUrl ||
        facebookReviewUrl ||
        googleReviewUrl
      ) {
        return true
      }
    }
    return false
  }

  return (
    <div className="p-2">
      <div className="grid gap-3 p-3">
        <div className="col-12">
          <h3 style={{ color: '#333', textAlign: 'center', marginBottom: 0 }}>
            {t('YourResults')}
          </h3>
        </div>
        <div
          className="col-12 border-round"
          style={{ background: branding?.leaderboard.backgroundColor }}
        >
          <p style={{ color: branding?.leaderboard.textColor }}>
            {t('TeamName')}
          </p>

          <h3
            className="mt-1"
            style={{ color: branding?.leaderboard.textColor }}
          >
            {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore */}
            {teamOnLeaderboard?.teamName}
          </h3>
        </div>
        <div
          className="col border-round"
          style={{ background: branding?.leaderboard.backgroundColor }}
        >
          <p style={{ color: branding?.leaderboard.textColor }}>{t('Score')}</p>

          <h3
            className="mt-1"
            style={{ color: branding?.leaderboard.textColor }}
          >
            {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore */}
            {teamOnLeaderboard?.score}
          </h3>
        </div>
        <div
          className="col border-round"
          style={{ background: branding?.leaderboard.backgroundColor }}
        >
          <p style={{ color: branding?.leaderboard.textColor }}>
            {t('Position')}
          </p>

          <h3
            className="mt-1"
            style={{ color: branding?.leaderboard.textColor }}
          >
            {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore */}
            {teamOnLeaderboard?.position}
          </h3>
        </div>
        <div
          className="col-12 border-round"
          style={{ background: branding?.leaderboard.backgroundColor }}
        >
          <p style={{ color: branding?.leaderboard.textColor }}>
            {t('TotalTime')}
          </p>
          <h3
            className="mt-1"
            style={{ color: branding?.leaderboard.textColor }}
          >
            {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore */}
            {getTimeSpentOnPuzzles(teamOnLeaderboard?.totalSeconds)}
          </h3>
        </div>
      </div>
      {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore */}
      {showRateAndSocial && teamOnLeaderboard?.socialShareUrl && (
        <>
          <h4 style={{ color: '#333' }} className="text-center">
            {t('Share')}
          </h4>
          <div className="col-12 flex justify-content-center align-items-center">
            <FacebookShareButton
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              url={teamOnLeaderboard?.socialShareUrl}
              quote={'Dummy text!'}
              hashtag="#muo"
              // className="mr-2"
            >
              <FacebookIcon
                bgStyle={{
                  fill: '#fff',
                  // stroke: '#000',
                  // strokeWidth: 4,
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  // r: 30,
                }}
                iconFillColor="#000"
                size={40}
                round
              />
            </FacebookShareButton>
            <TwitterShareButton
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              url={teamOnLeaderboard?.socialShareUrl}
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              quote={'Dummy text!'}
              hashtag="#muo"
              className="mx-2"
            >
              <TwitterIcon
                bgStyle={{
                  fill: '#fff',
                  // stroke: '#000',
                  // strokeWidth: 4,
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  // r: 30,
                }}
                iconFillColor="#000"
                size={40}
                round
              />
            </TwitterShareButton>
            <LinkedinShareButton
              // className="mr-2"
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              url={teamOnLeaderboard?.socialShareUrl}
            >
              <LinkedinIcon
                bgStyle={{
                  fill: '#fff',
                  // stroke: '#000',
                  // strokeWidth: 4,
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  // r: 30,
                }}
                iconFillColor="#000"
                size={40}
                round
              />
            </LinkedinShareButton>
            <WhatsappShareButton
              className="mx-2"
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              url={teamOnLeaderboard?.socialShareUrl}
              title="Title"
              separator=":: "
            >
              <WhatsappIcon
                bgStyle={{
                  fill: '#fff',
                  // stroke: '#000',
                  // strokeWidth: 4,
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  // r: 30,
                }}
                iconFillColor="#000"
                size={40}
                round
              />
            </WhatsappShareButton>
            <ViberShareButton
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              url={teamOnLeaderboard?.socialShareUrl}
              title="Title"
            >
              <ViberIcon
                bgStyle={{
                  fill: '#fff',
                  // stroke: '#000',
                  // strokeWidth: 4,
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  // r: 30,
                }}
                iconFillColor="#000"
                size={40}
                round
              />
            </ViberShareButton>
          </div>
          <CopyToClipboard
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            text={teamOnLeaderboard?.socialShareUrl}
            // className="w-full mt-3"
          >
            <div className="copy-area">
              <Button
                className="p-button-rounded p-button-outlined w-full sign-in-btn mt-1 uppercase"
                // style={{ background: '#c8d5db', color: '#333' }}
                label={t('CopyShareUrl')}
                // icon="pi pi-copy"
                // icon={
                //   <Copy
                //     // size="55"
                //     color="#DF6436"
                //     variant="Bold"
                //     className="mr-1"
                //   />
                // }
                icon={
                  <>
                    <div
                      className="p-2 p-button-icon p-button-icon-right rounded-icon-style-secondary"
                      style={{
                        backgroundColor: branding?.buttonSecondary.textColor,
                      }}
                    >
                      {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
                    </div>
                    <Copy
                      color={branding?.buttonSecondary.backgroundColor}
                      variant="Bold"
                      className="icon-center"
                      // className="p-button-icon p-c p-button-icon-right"
                    />
                  </>
                }
                style={{
                  backgroundColor: branding?.buttonSecondary.backgroundColor,
                  color: branding?.buttonSecondary.textColor,
                  border: `2px solid ${branding?.buttonSecondary.borderColor}`,
                }}
                onClick={() => {
                  dispatch(showSuccessNotification('Copied to clipboard!'))
                  clickSound()
                }}
              />
            </div>
          </CopyToClipboard>
          {/* <hr /> */}
        </>
      )}
      {showRateAndSocial && isAnyReviewFilled() && (
        <>
          <h4 style={{ color: '#333' }} className="text-center my-5">
            {t('Rate')}
          </h4>

          <div className="grid justify-content-center w-full mx-0 mb-5">
            {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore */}
            {teamOnLeaderboard?.tripAdvisorReviewUrl && (
              <RateButton
                icon="/assets/images/review/tripadvisor.png"
                label="Trip Advisor"
                // backgroundColor="#19cda0"
                onClick={() =>
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  window.open(teamOnLeaderboard?.tripAdvisorReviewUrl)
                }
              />
            )}
            {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore */}
            {teamOnLeaderboard?.yelpReviewUrl && (
              <RateButton
                icon="/assets/images/review/yelp.png"
                label="Yelp"
                // backgroundColor="#d32424"
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                onClick={() => window.open(teamOnLeaderboard?.yelpReviewUrl)}
              />
            )}
            {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore */}
            {teamOnLeaderboard?.facebookReviewUrl && (
              <RateButton
                icon="/assets/images/review/facebook.png"
                label="Facebook"
                // backgroundColor="#507dd2"
                onClick={() =>
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  window.open(teamOnLeaderboard?.facebookReviewUrl)
                }
              />
            )}
            {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore */}
            {teamOnLeaderboard?.googleReviewUrl && (
              <RateButton
                icon="/assets/images/review/google.png"
                label="Google"
                // backgroundColor="#f0faff"
                textColor="#333"
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                onClick={() => window.open(teamOnLeaderboard?.googleReviewUrl)}
              />
            )}
          </div>
        </>
      )}

      {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore */}
      {teamOnLeaderboard?.promoCode && (
        <div className="col-12 flex flex-column text-center justify-content-center align-items-center mt-4">
          {/* </div> */}

          <>
            <p>{t('YouCanUsePromoCode')}</p>
            {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore */}
            <h2 className="m-0">{teamOnLeaderboard?.promoCode}</h2>
          </>
        </div>
      )}
      <DataTable
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        value={leaderboard?.items}
        header={header}
        rowsPerPageOptions={[10, 25, 50]}
        dataKey="id"
        rowHover
        // selection={selectedCustomers}
        loading={
          gameLoading.isCheckingGameCode ||
          gameLoading.isLoadingTeamOnLeaderboard ||
          gameLoading.isLoadingLeaderboard
        }
        emptyMessage={t('NoTeamsFound')}
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        totalRecords={leaderboard?.totalCount}
        lazy
        // first={first}
        rowClassName={rowClass}
        className="leaderboard-table mb-3"
        paginator
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        paginatorTemplate={template2}
        // paginatorTemplate={templatePaginator}
        first={pagination.first}
        rows={pagination.rows}
        onPage={onPage}
        responsiveLayout="scroll"
      >
        <Column header={t('Num')} body={onIndexTemplate} />
        <Column field="teamName" header={t('TeamName')}></Column>
        <Column field="score" header={t('Score')}></Column>
        <Column
          field="totalSeconds"
          header={t('TimeSpent')}
          body={timeSpentBodyTemplate}
        ></Column>
        <Column
          field="isGameCompleted"
          header={t('IsCompleted')}
          body={(rowData: any) => (rowData.isGameCompleted ? 'Yes' : 'No')}
        ></Column>
      </DataTable>
      <div className="flex flex-column justify-content-between align-items-center">
        <Button
          label={GameType !== 'Indoor' ? t('BackToMap') : t('BackToMainScreen')}
          onClick={() => {
            clickSound()
            navigate('/game')
          }}
          type="button"
          // icon={<Map color="#DF6436" variant="Bold" className="mr-1" />}
          icon={
            <>
              <div
                className="p-2 p-button-icon p-button-icon-right rounded-icon-style-secondary"
                style={{ backgroundColor: branding?.buttonSecondary.textColor }}
              >
                {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
              </div>
              <Map
                color={branding?.buttonSecondary.backgroundColor}
                variant="Bold"
                className="icon-center"
                // className="p-button-icon p-c p-button-icon-right"
              />
            </>
          }
          className="p-button-rounded p-button-outlined w-full zoominleft animation-duration-1000 uppercase"
          // className="p-button-rounded p-button-outlined w-full sign-in-btn zoominleft animation-duration-1000"
          style={{
            backgroundColor: branding?.buttonSecondary.backgroundColor,
            color: branding?.buttonSecondary.textColor,
            border: `2px solid ${branding?.buttonSecondary.borderColor}`,
          }}
        />

        <Button
          label={t('Logout')}
          onClick={() => {
            clickSound()
            navigate('/')
          }}
          // onClick={() => setVisible(true)}
          type="button"
          icon={
            <>
              <div
                className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                style={{
                  backgroundColor: branding?.buttonPrimary.textColor,
                }}
              >
                {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
              </div>
              <Logout
                color="#fff"
                variant="Bold"
                className="icon-center"
                style={{
                  backgroundColor: branding?.buttonPrimary.backgroundColor,
                  color: branding?.buttonPrimary.backgroundColor,
                }}
                // className="p-button-icon p-c p-button-icon-right"
              />
            </>
          }
          // icon="pi pi-check"
          // iconPos="right"
          // icon={<Logout color="#fff" variant="Bold" className="mr-1" />}
          // className="p-button-rounded mt-2 p-button-raised  w-full sign-in-btn"
          className="p-button-rounded mt-2 p-button-raised  w-full uppercase"
          style={{
            backgroundColor: branding?.buttonPrimary.backgroundColor,
            color: branding?.buttonPrimary.textColor,
          }}
        />
      </div>
    </div>
  )
}

export default Leaderboard
